import _ from "lodash";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { URL } from "../../../../constant";
import { useLearningHistory } from "../../../../hooks";
import XbtnTitleHeader from "../../../common/header/XbtnTitleHeader";

const DiagnosisGuide2 = () => {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const { onLearningExitBtn } = useLearningHistory();

  const goExitPage = useCallback(() => {
    onLearningExitBtn();
  });

  const goBackPage = useCallback(() => {
    if(location.pathname === URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.DiagnosisGuide2) {
      history.replace(`${URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.DiagnosisGuide1}`);
    } else {
      history.goBack();
    }
  });

  const goNextPage = useCallback(() => {
    history.push(`${URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.DIAGNOSIS_GUIDE3}`);
  });

  return (
    <div className="layout-def layout-lc">
      <XbtnTitleHeader title={t("LC_02_02.msg001")} onClose={goExitPage} />
      <div className="container">
        <div className="inner">
          <div className="centermiddleBox">
            <div className="centermiddleBox-row">
              <div className={`dsc_cont2 ${getlanClass()}`}>
                <div className="aic-intro">
                  <div className="aic-intro-item">
                    <h2 className="tit">{t("LC_02_02.msg003")}</h2>
                  </div>
                  <ol className="con_lst">
                    <li>
                      <span className="num">1</span>
                      <img
                        src={`${process.env.PUBLIC_URL}/static/images/common/diagnostic/img_notice_01.png`}
                        alt=""
                      />
                      <p
                        className="sub_txt"
                        dangerouslySetInnerHTML={{
                          __html: t("LC_02_02.msg004"),
                        }}
                      />
                    </li>

                    <li>
                      <span className="num">2</span>
                      <img
                        src={`${process.env.PUBLIC_URL}/static/images/common/diagnostic/img_notice_02.png`}
                        alt=""
                      />
                      <p
                        className="sub_txt"
                        dangerouslySetInnerHTML={{
                          __html: t("LC_02_02.msg005"),
                        }}
                      />
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="footer-inner">
          <div className="d-flex">
            <div className="d-item">
              <button
                className={`btn-small btn-gray btn-left ${getlanClass()}`}
                onClick={goBackPage}
              >
                <span className="m-txt">{t("LC_02_02.msg006")}</span>
              </button>
            </div>
            <div className="d-item btnItem-auto">
              <button
                className={`btn btn-blue ${getlanClass()}`}
                onClick={goNextPage}
              >
                {t("LC_02_02.msg007")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiagnosisGuide2;

const getlanClass = () => {
  const { i18n } = useTranslation();
  return _.isEqual(i18n.language === "ko") ? "ko" : "en";
};